const elBasketWholesale = document.querySelector('.basket-wholesale_basket');

if (elBasketWholesale) {
    Promise.all([
        import('react'),
        import('react-dom'),
        import('Bem/site/basket-wholesale/basket-wholesale.jsx'),
    ])
        .then(([
            { default: React },
            { default: ReactDOM },
            { BasketWholesaleJSX },
        ]) => {
            ReactDOM.render(
                <BasketWholesaleJSX />,
                elBasketWholesale,
            );

            elBasketWholesale.classList.add('basket-wholesale_init');
        });
}